export function allowEditHelps(person) {
  if (!person) return false;
  return person.isHelperEditor;
}

export function allowEditTilausData(keikkaData) {
  try {
    if (keikkaData == null) return true; //  saa muokata jos ei ole mitään muokattavaa
    const edit = keikkaData.auth.edit;
    const isKeikkaAdmin = keikkaData.auth.isKeikkaAdmin;
    const isMuokkausTila = keikkaData.tila.muokkausTila;
    const tila = keikkaData.tila;
    if (keikkaData.locked) return false; // jos keikka on lukittu niin ei saa muokata
    if (!edit) return false; // jos ei edit moodissa niin ei saa muokata tilausdataa
    if (tila.isLuonnos) return true; // saa moukata jos tila on luonnos
    if (isKeikkaAdmin) {
      if (tila.isLahetetty) return true; // saa muokata jos tila on lähetetty ja käyttäjä on keikka admin
      if (tila.isKasiteltavana) return true; // saa muokata jos tila on käsiteltävänä ja käyttäjä on keikka admin
      if (isMuokkausTila) {
        if (tila.isToimitusvalmis) return true; // saa muokata jos tila on toimitusvalmis ja muokkaustila on päällä ja käyttäjä on keikka admin
        if (tila.isToimitusAloitettu) return true; // saa muokata jos tilauksen toimitus on aloitettu ja muokkaustila on päällä ja käyttäjä on keikka admin
        if (tila.isOtherTila) return true; // saa muokata jos tilauksen toimitus on aloitettu ja muokkaustila on päällä ja käyttäjä on keikka admin
      }
    }
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export function allowChangeIsTarjous(keikkaData) {
  // saako vaihtaa onko tilaus vai tarjous
  return allowEditTilausData(keikkaData);
}
export function allowChangeHasBetoni(keikkaData) {
  // saako vaihtaa onko betoni moduli vai ei
  return allowEditTilausData(keikkaData);
}
export function allowChangeHasPumppu(keikkaData) {
  // saako vaihtaa onko pumppu moduli vai ei
  return allowEditTilausData(keikkaData);
}
export function allowChangeHasLattia() {
  // saako vaihtaa onko lattia moduli vai ei
  return false;
}
export function allowChangeHasToimitus(keikkaData) {
  // saako vaihtaa tehdäänkö tilaukselle toimitus vai ei
  return allowEditTilausData(keikkaData);
}

export function allowEditPumppuToimitusData(toimitus, keikkaData) {
  try {
    if (!toimitus) return false;
    if (!keikkaData) return false;
    if (!keikkaData.modules.hasToimitus) return false;

    if (toimitus.isLocked) {
      // toimitus is locked
      if (keikkaData.tila.muokkausTila && keikkaData.auth.isKeikkaAdmin) {
        // saa moukata jos toimitus on lukittu ja muokkaustila on päällä ja käyttäjä on keikka admin
        return true;
      }
    } else {
      // toimitus is unlocked
      if (keikkaData.auth.isPumppari) {
        // saa moukata jos käyttäjä on pumppari ja toimitus ei ole lukittu
        return true;
      }
      if (keikkaData.auth.isKeikkaAdmin) {
        // saa moukata jos käyttäjä on keikka admin ja toimitus ei ole lukittu
        return true;
      }
    }
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export function allowEditGlobalTyömaa(tyomaa, user) {
  if (!user || !tyomaa) return false;
  if (user.isKeikkaAdmin) return true;
  if (user.personId == tyomaa.tyomaaContactPersonId) return true;
  if (tyomaa.auth.edit) return true;
  return false;
}
export function allowEditKeikkaTyömaa(keikkaData) {
  if (!allowEditTilausData(keikkaData)) return false;
  if (!keikkaData) return false;
  const tyomaa = keikkaData.tyomaa;
  if (tyomaa.tyomaaId > 0 && tyomaa.auth.edit) return true;
  if (keikkaData.auth.isKeikkaAdmin) return true;
  if (keikkaData.auth.edit) return true;
  if (keikkaData.tyomaa.auth.edit) return true;
  return false;
}

export function allowChangeTyömaaForKeikka(keikkaData, user) {
  try {
    if (!keikkaData || !user) return false;
    const a =
      keikkaData.auth.edit &&
      (keikkaData.tyomaa.tyomaaId == 0 ||
        keikkaData.tyomaa.auth.edit ||
        keikkaData.asiakas.auth.edit ||
        keikkaData.keikkaContactPerson.personId == user.personId);
    return a;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export function allowChangeBetoniToimittaja(keikkaData) {
  if (!keikkaData) return false;
  if (!keikkaData.modules.hasBetoni) return false;
  if (!keikkaData.auth.isKeikkaAdmin) return false;
  if (keikkaData.auth.edit) return true;
  return !keikkaData.tila.isToimitettu;
}
export function allowChangePumppari(keikkaData) {
  return keikkaData.auth.edit;
}
export function allowChangePumppuToimittaja(keikkaData) {
  if (!keikkaData) return false;
  if (!keikkaData.modules.hasPumppu) return false;
  return (
    keikkaData.auth.edit &&
    keikkaData.tyomaa.auth.edit &&
    !keikkaData.tila.isToimitusAloitettu &&
    keikkaData.auth.isKeikkaAdmin
  );
}

export function allowEditGlobalAsiakas(user, asiakas) {
  if (!user || !asiakas) return false;
  if (user.personId == asiakas.asiakasContactPersonId) return true;
  if (asiakas.auth.edit || asiakas.auth.originalEdit) return true;
  if (asiakas.auth.isAsiakasEditor) return true;
  if (asiakas.auth.isAsiakasAdmin) return true;
  if (user.isKeikkaAdmin) {
    if (asiakas.ownerAsiakasId == null) return true;
    if (user.asiakasListContains(asiakas.ownerAsiakasId)) return true;
  }

  //if (person.isSystemAdmin) return true;
  return false;
}

export function allowEditKeikkaAsiakas(keikkaData) {
  if (!keikkaData) return false;
  if (!allowEditTilausData(keikkaData)) return false;
  const asiakas = keikkaData.asiakas;
  if (keikkaData) {
    if (keikkaData.asiakas.asiakasId > 0 && keikkaData.asiakas.auth.edit) return true;
    if (keikkaData.auth.isKeikkaAdmin) return true;
  }
  if (asiakas && asiakas.asiakasId > 0) {
    if (asiakas.auth.edit) return true;
  }
  return false;
}
export function allowEditAsiakasHuomioita(keikkaData, asiakas = null) {
  if (!keikkaData && !asiakas) return false;
  if (keikkaData && keikkaData.keikkaId > 0) {
    if (keikkaData.asiakas.auth.edit) return true;
    if (keikkaData.auth.isKeikkaAdmin) return true;
  } else if (asiakas && asiakas.asiakasId > 0) {
    console.log(asiakas.auth);
    if (asiakas.auth.edit) return true;
    if (asiakas.isAsiakasAdmin) return true;
    if (asiakas.isAsiakasEditor) return true;
  }

  return false;
}
export function allowChangeAsiakasMainContact(asiakas, user) {
  if (!user || !asiakas) return false;
  if (user.isKeikkaAdmin) return true;
  if (user.personId == asiakas.asiakasContactPersonId) return true;
  if (asiakas.auth?.edit) return true;
  if (asiakas.auth?.isAsiakasAdmin) return true;
  return false;
}
export function allowListAsiakasPersons(asiakas, user) {
  return allowChangeAsiakasMainContact(asiakas, user);
}
export function allowEditAsiakasSijainnit(asiakas, user) {
  return allowChangeAsiakasMainContact(asiakas, user);
}
export function allowEditAsiakasAsetukset(asiakas, user) {
  return user.isSystemAdmin || user.isRoleManager;
}
export function allowDeleteAsiakasPerson(asiakas, user) {
  return allowChangeAsiakasMainContact(asiakas, user);
}
export function allowDeleteKeikkaPerson(keikkaData, user) {
  return allowChangeAsiakasMainContact(keikkaData.asiakas, user);
}
export function allowDeleteTyomaa(user, tyomaa) {
  if (!user || !tyomaa) return false;
  if (tyomaa.auth.createKeikka) return true;
  if (user.isSystemAdmin) return true;
  return false;
}
export function allowDeleteTyomaaPerson(tyomaa, user) {
  if (!tyomaa || !user) return false;
  const a = tyomaa.auth.addPerson;
  const b = user.isAnyAdmin;
  return a && b;
}
export function allowAddAsiakasPerson(asiakas, user) {
  return allowChangeAsiakasMainContact(asiakas, user);
}
export function allowViewAsiakasPersons(asiakas, user) {
  return allowChangeAsiakasMainContact(asiakas, user);
}

export function allowChangeAsiakasForKeikka(keikkaData) {
  if (!keikkaData) return false;
  const a =
    keikkaData.auth.edit &&
    (keikkaData.tila.isLuonnos ||
      keikkaData.tila.isMuokkausTila ||
      keikkaData.tila.isKasiteltavana);
  return a;
}

export function allowAddNewAsiakas(keikkaData) {
  if (!keikkaData) return false;
  return keikkaData.auth.edit && (keikkaData.tila.isLuonnos || keikkaData.tila.isMuokkausTila);
}

export function allowAddPersonToKeikka(keikkaData) {
  if (!keikkaData) return false;
  return keikkaData.auth.addPerson || keikkaData.auth.isKeikkaAdmin;
}

export function allowSwitchBetoniOrder(betoni, keikkaData) {
  if (!keikkaData) return false;
  return !betoni.betoniError(false) && allowEditTilausData(keikkaData) && !keikkaData.isLoading;
}

export function saaLuodaLaskun(user, laskuttajaAsiakas) {
  if (!user) return false;
  if (!laskuttajaAsiakas) return false;
  const saaLuodaLaskunSetting = laskuttajaAsiakas.auth.getAsiakasPersonSetting(5);
  if (saaLuodaLaskunSetting) return true;
  return false;
}

// export function saaNähdäLaskun(keikkaData, keikkaLasku, user, laskuttajaType = "pumppu") {
//   if (!user) return false;
//   if (!keikkaData) return false;
//   //return person.isSystemAdmin;
//   const _saaNähdäHinnat = saaNähdäHinnat(user, keikkaData, keikkaLasku, laskuttajaType);
//   if (!_saaNähdäHinnat) return false;
//   // hae saaNähdäLaskunSetting vastaanottavalta asiakkaalta
//   const _saaNähdäLaskun = keikkaData.asiakas.auth.getAsiakasPersonSetting(7);
//   if (_saaNähdäLaskun) return true;
//   return false;
// }

export function allowChangeAsiakasRoles(user) {
  return user.isSystemAdmin || user.isRoleManager;
}

export function allowImpersonate(user) {
  return user.isSystemAdmin || user.isRoleManager;
}

export function allowEditGridKeikka(user, userAsiakas, gridKeikka) {
  try {
    if (!user) return false;
    if (!gridKeikka) return false;
    if (!userAsiakas) return false;
    // if (gridKeikka.keikkaTilaId === 100) return false;
    if (gridKeikka.ownerAsiakasId !== userAsiakas.asiakasId) return false;
    if (user.isAnyAdmin) return true;
    if (user.isRoleManager) return true;
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
}
